export default {
  title: '結帳購物車',
  type: 'post',
  body: [
    {
      title: '成功',
      body: {
        "code": 200,
        "message": "success",
        "status": "SUCCESS",
        "data": null
      }
    }
  ]
}
